var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{style:({ color: _vm.color }),attrs:{"icon":['fas', 'star']}})}
var staticRenderFns = []

export { render, staticRenderFns }